interface PersonalProject {
  _id: string;
  title: string;
  description: string;
  category: string;
  status: 'Planning' | 'Active' | 'Completed' | 'On Hold';
  progress: number;
  sourceIdeaId?: string;
  createdAt: string;
  updatedAt: string;
}

interface CreateProjectData {
  title: string;
  description: string;
  category: string;
  status?: string;
  sourceIdeaId?: string;
}

const API_BASE_URL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://findashback.onrender.com';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

function getAuthHeaders() {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
}

// Get all projects
const getProjects = async (): Promise<PersonalProject[]> => {
  try {
    const response = await fetch(`${API_BASE_URL()}/api/projects`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.projects || [];
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

// Create a new project
const createProject = async (projectData: CreateProjectData): Promise<PersonalProject> => {
  try {
    const response = await fetch(`${API_BASE_URL()}/api/projects`, {
      method: 'POST',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify({
        ...projectData,
        status: projectData.status || 'Planning',
        progress: 0
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.project;
  } catch (error) {
    console.error('Error creating project:', error);
    throw error;
  }
};

// Update a project
const updateProject = async (projectId: string, updateData: Partial<PersonalProject>): Promise<PersonalProject> => {
  try {
    // Always include title and sourceIdeaId if present
    const bodyData = {
      ...updateData,
      // ...(updateData.title ? { projectName: updateData.title } : {}),
      
    };
    console.log("BODY DATA", bodyData);
    const response = await fetch(`${API_BASE_URL()}/api/projects/${projectId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      credentials: 'include',
      body: JSON.stringify(bodyData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.project;
  } catch (error) {
    console.error('Error updating project:', error);
    throw error;
  }
};

// Delete a project
const deleteProject = async (projectId: string): Promise<void> => {
  try {
    const response = await fetch(`${API_BASE_URL()}/api/projects/${projectId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  } catch (error) {
    console.error('Error deleting project:', error);
    throw error;
  }
};

export const personalProjectsApi = {
  getProjects,
  createProject,
  updateProject,
  deleteProject
};

export type { PersonalProject, CreateProjectData };
